import {gql} from '@apollo/client';
import {BUILDER_BANK_ACCOUNT, BUILDER_POT} from './builderPotFragments';

export const BUILDER_CONTRIBUTE_POTS = gql`
  ${BUILDER_POT}
  ${BUILDER_BANK_ACCOUNT}
  query BuilderContributePots($reviewId: UUID!, $contactId: UUID, $potType: String!) {
    contributePots(reviewId: $reviewId, contactId: $contactId, potType: $potType) {
      # Sources are a union: existing plans plus the client's bank accounts
      # (DBO-1439). CashPotType only ever appears in saved details.
      sources {
        ... on PotType {
          ...BuilderPot
        }
        ... on BankAccountType {
          ...BuilderBankAccount
        }
      }
      employerSources {
        ...BuilderBankAccount
        account {
          id
          name
        }
      }
      destinations {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_WITHDRAW_POTS = gql`
  ${BUILDER_POT}
  query BuilderWithdrawPots($reviewId: UUID!, $contactId: UUID, $potType: String!) {
    withdrawPots(reviewId: $reviewId, contactId: $contactId, potType: $potType) {
      sources {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_WITHDRAW_DESTINATIONS = gql`
  ${BUILDER_BANK_ACCOUNT}
  query BuilderWithdrawDestinations(
    $reviewId: UUID!
    $sourcePotId: UUID!
    $contactId: UUID
  ) {
    withdrawDestinationBankAccounts(
      reviewId: $reviewId
      sourcePotId: $sourcePotId
      contactId: $contactId
    ) {
      ...BuilderBankAccount
    }
  }
`;

export const BUILDER_TRANSFER_POTS = gql`
  ${BUILDER_POT}
  query BuilderTransferPots($reviewId: UUID!, $contactId: UUID, $potType: String!) {
    transferPots(reviewId: $reviewId, contactId: $contactId, potType: $potType) {
      sources {
        ...BuilderPot
      }
      destinations {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_MODIFY_POTS = gql`
  ${BUILDER_POT}
  query BuilderModifyPots($reviewId: UUID!, $contactId: UUID, $potType: String!) {
    modifyPots(reviewId: $reviewId, contactId: $contactId, potType: $potType) {
      sources {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_ANNUITY_POTS = gql`
  ${BUILDER_POT}
  query BuilderAnnuityPots($reviewId: UUID!, $contactId: UUID!) {
    annuityPots(reviewId: $reviewId, contactId: $contactId) {
      sources {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_AD_HOC_FEE_POTS = gql`
  ${BUILDER_POT}
  query BuilderAdHocFeePots($reviewId: UUID!, $contactId: UUID, $potType: String!) {
    adHocFeePots(reviewId: $reviewId, contactId: $contactId, potType: $potType) {
      sources {
        ...BuilderPot
      }
    }
  }
`;

export const BUILDER_LIST_POTS = gql`
  ${BUILDER_POT}
  query BuilderListPots(
    $accountId: UUID!
    $contactId: UUID
    $parentOnly: Boolean
    $banksOnly: Boolean
    $curoSync: Boolean!
  ) {
    pots(
      accountId: $accountId
      curoSync: $curoSync
      contactId: $contactId
      parentOnly: $parentOnly
      banksOnly: $banksOnly
    ) {
      ...BuilderPot
    }
  }
`;
